// test155
(155 && 0);
